module.exports = __webpack_public_path__ + "static/calloutIntegration-a7682f699692c417e3a17d8aab421a6c.jpg";